import { render, staticRenderFns } from "./SubCategoriasFormComponent.vue?vue&type=template&id=c8b4da9a&"
import script from "./SubCategoriasFormComponent.vue?vue&type=script&lang=js&"
export * from "./SubCategoriasFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports